/**
 * Parse Google Places address_components into fields (same logic as BasicInfo).
 * @param {google.maps.places.PlaceResult | { address_components?: Array<{ long_name: string, short_name: string, types: string[] }> }} place
 * @returns {{ street: string, city: string, province: string, postalCode: string, country: string, countryShort: string }}
 */
export function parseGooglePlaceAddress(place) {
  const components = place?.address_components || [];
  const get = (type, short = false) => {
    const comp = components.find((c) => c.types.includes(type));
    if (!comp) return '';
    return short ? comp.short_name : comp.long_name;
  };
  const street = [get('street_number'), get('route')].filter(Boolean).join(' ').trim();
  const city =
    get('locality') ||
    get('administrative_area_level_2') ||
    get('sublocality') ||
    get('postal_town') ||
    '';
  return {
    street,
    city,
    province: get('administrative_area_level_1', true),
    postalCode: get('postal_code'),
    country: get('country', false),
    countryShort: get('country', true),
  };
}
